import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_CAMPAIGN_INFLUENCERS_FACETS_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useGetCampaignInfluencersFacets(briefId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...BRIEF_CAMPAIGN_INFLUENCERS_FACETS_QUERY_KEY(briefId)],
    queryFn: () => CampaignService.getCampaignInfluencersFacets(briefId),
    enabled: !!briefId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data?.taskCounts || [],
    isLoading,
    isError,
    actionPendingOnBrand: data?.data?.actionPendingOnBrand || 0,
    anyTaskCompletedCampaignInfluencers:
      data?.data?.anyTaskCompletedCampaignInfluencers || 0,
  };
}
